import i18next from 'i18next';
import { _URL_FORM, abrirFormCadastro, fecharFormCadastro } from './helpers';
import { janelaAjuda } from './janelaAjuda';
import { progressoCurriculo } from './progresso';

// declarado p/ strict mode (era global implicito)
var content;

export const informatica = function () {
    "use strict";

    var $divPanel = '#panel-informatica';
    var $panel = body.find($divPanel);

    // CurriculoInformatica.Nome tem 100 chars e o DataAccess ja corta em silencio. Limitar aqui evita
    // tanto o token gigante que estoura o layout quanto o texto salvo truncado sem o candidato perceber.
    var MAX_CARACTERES_INFORMATICA = 100;
    var _limitarTamanhoToken = function (token) {
        return $.trim(token).substring(0, MAX_CARACTERES_INFORMATICA);
    };
    var _excluir = function (id) {
        swal({
            title: i18next.t('informaticaRemover'),
            html: i18next.t('informaticaRemoverDesc'),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: i18next.t('btnSimRemover'),
            cancelButtonText: i18next.t('btnCancelar'),
            closeOnConfirm: true
        }, function () {
            window.global.loaderPanel.show($divPanel);
            $.ajax({
                type: "POST",
                url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DeleteInformatica',
                data: { id: id },
                cache: false,
                success: function (data) {
                    window.global.loaderPanel.hide($divPanel);
                    if (data.success == '0') {
                        swal("", data.error, "error");
                    } else {
                        toastr.success(i18next.t('informaticaRemoverSucesso'), '', { "closeButton": true });
                        $panel.find('#informatica-item-' + id).remove();
                        progressoCurriculo();
                    }
                },
                error: function () {
                    window.global.loaderPanel.show($divPanel);
                    swal("", i18next.t('erroServidor'), "error");
                }
            });
        });

    };
    var _listar = function () {
        window.global.loaderPanel.show($divPanel);

        $.ajax({
            type: "GET",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/GetInformaticaSelected', cache: false,

            success: function (dados) {
                var html = [], htmlAvancado = [], htmlIntermediario = [], htmlBasico = [], dataAvancado = [], dataIntermediario = [], dataBasico = [], elementNull = document.getElementById("informatica-null");

                if (dados != '') {
                    for (var i = 0; i < dados.length; i++) {
                        if (dados[i].Nivel == 3) {
                            dataAvancado.push({
                                "id": dados[i].Nome,
                                "name": dados[i].Nome
                            });
                            htmlAvancado.push('<div class="cursor-default btn btn-sm  btn-label btn-label-default-outline mt5 mr5" data-tipo="3" data-nome="' + dados[i].Nome + '" id="informatica-item-' + dados[i].ID + '">' + dados[i].Nome + ' <span class="token-input-delete-token-facebook cursor-pointer ml5" data-id="' + dados[i].ID + '">×</span></div>');
                        } else if (dados[i].Nivel == 2) {
                            dataIntermediario.push({
                                "id": dados[i].Nome,
                                "name": dados[i].Nome
                            });
                            htmlIntermediario.push('<div class="cursor-default btn btn-sm btn-label btn-label-default-outline mt5 mr5" data-tipo="2" data-nome="' + dados[i].Nome + '" id="informatica-item-' + dados[i].ID + '">' + dados[i].Nome + ' <span class="token-input-delete-token-facebook cursor-pointer ml5" data-id="' + dados[i].ID + '">×</span></div>');
                        } else {
                            dataBasico.push({
                                "id": dados[i].Nome,
                                "name": dados[i].Nome
                            });
                            htmlBasico.push('<div class="cursor-default btn btn-sm  btn-label btn-label-default-outline mt5 mr5" data-tipo="1" data-nome="' + dados[i].Nome + '" id="informatica-item-' + dados[i].ID + '">' + dados[i].Nome + ' <span class="token-input-delete-token-facebook cursor-pointer ml5" data-id="' + dados[i].ID + '">×</span></div>');

                        }
                    }
                    elementNull.className = 'hide';
                    if (dataAvancado.length > 0) {
                        html.push('<li class="list-group-item"><h4 class="nomargin"><b>' + i18next.t('informaticaAvancado') + '</b></h4>' + htmlAvancado.join('') + '</li>');
                    }
                    if (dataIntermediario.length > 0) {
                        html.push('<li class="list-group-item"><h4 class="nomargin"><b>' + i18next.t('informaticaIntermediario') + '</b></h4>' + htmlIntermediario.join('') + '</li>');
                    }
                    if (dataBasico.length > 0) {
                        html.push('<li class="list-group-item"><h4 class="nomargin"><b>' + i18next.t('informaticaBasico') + '</b></h4>' + htmlBasico.join('') + '</li>');
                    }
                    document.getElementById('informatica-lista').innerHTML = html.join('');
                    $panel.find('.token-input-delete-token-facebook').on('click', function (e) {
                        _excluir($(this).attr('data-id'));
                        e.preventDefault();
                    });
                    $panel.find('.btn-add').removeClass('hide');

                } else {
                    elementNull.className = '';
                    document.getElementById('informatica-lista').innerHTML = '';
                }
                window.global.loaderPanel.hide($divPanel);

            },
            error: function () {
                window.global.loaderPanel.hide($divPanel);
            }
        });
    };
    var _salvar = function () {
        var $form = $panel.find('#form-informatica');
        window.global.loaderButton.show($form.find('button[type=submit]'));

        $.ajax({
            type: "POST",
            url: $form.attr('action'), cache: false,
            data: $form.serialize(),
            success: function (data) {
                if (data.success == 1) {
                    toastr.success(i18next.t('informaticaSalva'), '', { "closeButton": true });
                    _listar();
                    progressoCurriculo();
                    _fechar();
                }
                else {
                    swal("", data.error, "error");
                    window.global.loaderButton.hide(content.find('button[type=submit]'));
                }

            },
            error: function () {
                window.global.loaderButton.hide(content.find('button[type=submit]'));
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };
    var _fechar = function () {
        document.getElementById('informatica-contentform').innerHTML = '';
        goToByScroll($divPanel);
        fecharFormCadastro();
    };
    var _abrir = function () {
        goToByScroll($divPanel);

        window.global.loaderFull.show();
        //window.global.loaderPanel.show($divPanel);
        var formulario = $panel.find('#informatica-contentform');
        abrirFormCadastro();
        formulario.load(_URL_FORM + "Informatica?v=3", function () {
            $.validate({
                form: '#form-informatica'
            });
            formulario.find('.close-panel').on('click', function (e) {
                _fechar();
                e.preventDefault();
            });
            formulario.find('#form-informatica').on('submit', function (e) {
                if ($(this).isValid()) {
                    _salvar();
                }
                e.preventDefault();
            });
            var dataAvancado = [], dataIntermediario = [], dataBasico = [];

            $panel.find('#informatica-lista').find('div').each(function (index) {
                var _this = $(this);
                if (_this.attr('data-tipo') == '3') {
                    dataAvancado.push({
                        "id": _this.attr('data-nome'),
                        "name": _this.attr('data-nome')
                    });
                }
                else if (_this.attr('data-tipo') == '2') {
                    dataIntermediario.push({
                        "id": _this.attr('data-nome'),
                        "name": _this.attr('data-nome')
                    });
                }
                else if (_this.attr('data-tipo') == '1') {
                    dataBasico.push({
                        "id": _this.attr('data-nome'),
                        "name": _this.attr('data-nome')
                    });
                }

            });
            formulario.find("#informatica-avancado").tokenInput('', {
                searchDelay: 400,
                minChars: 2,
                theme: 'facebook',
                hintText: i18next.t('informaticaDigiteAvancada'),
                noResultsText: i18next.t('informaticaAdd'),
                searchingText: i18next.t('informaticaAdd'),
                prePopulate: dataAvancado,
                allowFreeTagging: true,
                preventDuplicates: true,
                onFreeTaggingAdd: _limitarTamanhoToken
            });
            formulario.find("#informatica-intermediario").tokenInput('', {
                searchDelay: 400,
                minChars: 2,
                theme: 'facebook',
                hintText: i18next.t('informaticaDigiteIntermediaria'),
                noResultsText: i18next.t('informaticaAdd'),
                searchingText: i18next.t('informaticaAdd'),
                prePopulate: dataIntermediario,
                allowFreeTagging: true,
                preventDuplicates: true,
                onFreeTaggingAdd: _limitarTamanhoToken
            });
            formulario.find("#informatica-basico").tokenInput('', {
                searchDelay: 400,
                minChars: 2,
                theme: 'facebook',
                hintText: i18next.t('informaticaDigiteBasica'),
                noResultsText: i18next.t('informaticaAdd'),
                searchingText: i18next.t('informaticaAdd'),
                prePopulate: dataBasico,
                allowFreeTagging: true,
                preventDuplicates: true,
                onFreeTaggingAdd: _limitarTamanhoToken
            });
            // O maxlength barra a digitacao; o onFreeTaggingAdd cobre colar texto e o prePopulate.
            // ATENCAO ao seletor: com `theme: 'facebook'` o plugin reescreve TODAS as suas classes
            // com o sufixo do tema (jquery.tokeninput.js:244-248), entao a classe e
            // .token-input-input-token-facebook — sem o sufixo o seletor nao casa com nada.
            formulario.find('ul.token-input-list-facebook input[type="text"]').attr('maxlength', MAX_CARACTERES_INFORMATICA);

            janelaAjuda(formulario);

            setTimeout(() => {
                window.global.loaderFull.hide();
            }, 1000);
            //window.global.loaderPanel.hide($divPanel);
        });


    };

    var init = function () {
        _listar();

        $panel.find('.btn-add').on('click', function (e) {
            _abrir();
            e.preventDefault();
        });
    }

    return init();
};

